import React, {useState} from 'react';
import FCSelect from "../../../components/FCObjets/Form/FCSelect";
import "./CreateAccountUser.scss";
import {GetUsernameFree} from "../../../service/AccountService";

export interface InterfaceCreateAccountUser {
    username: string;
    firstname: string;
    lastname: string;
    password: string;
    civility: string;
    titleJob: string;
    urlCV: string;
    contactEmail: string;
    phoneNumber: string;
}

export type CreateAccountUserProps = {
    handlerChange: (dataUser: InterfaceCreateAccountUser) => void;
    verifyInput: boolean;
};

const CreateAccountUser: React.FC<CreateAccountUserProps> = (props: CreateAccountUserProps) => {
    const [inputPassword, setInputPassword] = useState("");
    const [inputPasswordVerify, setInputPasswordVerify] = useState("");
    const [diffPassword, setDiffPassword] = useState(false);

    const [usernameFree, setUsernameFree] = useState(true);
    const [inputUsername, setInputUsername] = useState("");

    const [dataUser, setDataUser] = useState<InterfaceCreateAccountUser>({
        civility: "", firstname: "", lastname: "", password: "", titleJob: "", urlCV: "", username: "", contactEmail: "", phoneNumber: ""
    });

    const optionCivility = [
        {value: "", label: "— Sélectionner —"},
        {value: "Monsieur", label: "Monsieur"},
        {value: "Madame", label: "Madame"},
        {value: "Non binaire", label: "Non binaire"},
    ];

    const eventChange = (key: keyof InterfaceCreateAccountUser, value: string) => {
        const v: InterfaceCreateAccountUser = {...dataUser, [key]: value};
        setDataUser(v);
        props.handlerChange(v);
    };

    const eventUsernameChanged = async (username: string) => {
        if (username.length > 0) {
            try {
                const response = await GetUsernameFree(username);
                const {free} = response.data;

                if (free) {
                    eventChange("username", username);
                } else {
                    eventChange("username", "");
                }
                setInputUsername(username);
                setUsernameFree(free);
            } catch (error) {
                console.error(error);
                setInputUsername("");
                eventChange("username", "");
            }
        } else {
            setInputUsername("");
            eventChange("username", "");
        }
    };

    const eventChangePass = (value: string, inputVerify: boolean) => {
        if (inputVerify) {
            setInputPasswordVerify(value);
        } else {
            setInputPassword(value);
        }

        if ((inputVerify && value !== inputPassword) ||
            (!inputVerify && value !== inputPasswordVerify)) {
            setDiffPassword(true);
        } else {
            setDiffPassword(false);
            eventChange("password", inputVerify ? inputPassword : value);
        }
    };

    const usernameError = (props.verifyInput && dataUser.username === "") || !usernameFree;
    const firstnameError = props.verifyInput && dataUser.firstname === "";
    const lastnameError = props.verifyInput && dataUser.lastname === "";
    const emailError = props.verifyInput && dataUser.contactEmail === "";
    const civilityError = props.verifyInput && dataUser.civility === "";
    const passwordError = diffPassword || (props.verifyInput && inputPassword === "") || (props.verifyInput && inputPassword.length > 0 && inputPassword.length < 8);
    const passwordVerifyError = diffPassword || (props.verifyInput && inputPasswordVerify === "");

    return (
        <>
            <div className="caSectionHeader">
                <h1 className="caSectionTitle">Données Utilisateurs</h1>
                <p className="caSectionSubtitle">
                    Renseignez vos informations personnelles pour établir votre identité professionnelle.
                </p>
            </div>

            <div className="caCard">
                <div className="caFormGrid">
                    <div className={`caField${usernameError ? " caFieldError" : ""}`}>
                        <label htmlFor="username">Username *</label>
                        <input id="username" type="text" placeholder="@johndoe"
                               defaultValue={inputUsername}
                               onBlur={(e) => eventUsernameChanged(e.target.value)}/>
                    </div>

                    <div className={`caField${emailError ? " caFieldError" : ""}`}>
                        <label htmlFor="email">Email Address *</label>
                        <input id="email" type="email" placeholder="john@example.com"
                               value={dataUser.contactEmail}
                               onChange={(e) => eventChange("contactEmail", e.target.value)}/>
                    </div>

                    <div className={`caField${firstnameError ? " caFieldError" : ""}`}>
                        <label htmlFor="firstname">Prénom *</label>
                        <input id="firstname" type="text" placeholder="John"
                               value={dataUser.firstname}
                               onChange={(e) => eventChange("firstname", e.target.value)}/>
                    </div>

                    <div className={`caField${lastnameError ? " caFieldError" : ""}`}>
                        <label htmlFor="lastname">Nom *</label>
                        <input id="lastname" type="text" placeholder="Doe"
                               value={dataUser.lastname}
                               onChange={(e) => eventChange("lastname", e.target.value)}/>
                    </div>

                    <div className="caField caFieldFull">
                        <label htmlFor="phone">Numéro de téléphone</label>
                        <input id="phone" type="tel" placeholder="+33 6 00 00 00 00"
                               value={dataUser.phoneNumber}
                               onChange={(e) => eventChange("phoneNumber", e.target.value)}/>
                    </div>
                </div>
            </div>

            <div className="caCard">
                <div className="caFormGrid">
                    <div className={`caField${passwordError ? " caFieldError" : ""}`}>
                        <label htmlFor="pass">Mot de passe * <span style={{fontWeight: 400, fontSize: "10px"}}>(min. 8 caractères)</span></label>
                        <input id="pass" type="password" placeholder="••••••••"
                               value={inputPassword}
                               onChange={(e) => eventChangePass(e.target.value, false)}/>
                    </div>

                    <div className={`caField${passwordVerifyError ? " caFieldError" : ""}`}>
                        <label htmlFor="pass2">Vérification mot de passe *</label>
                        <input id="pass2" type="password" placeholder="••••••••"
                               value={inputPasswordVerify}
                               onChange={(e) => eventChangePass(e.target.value, true)}/>
                    </div>

                    <div className={`caField${civilityError ? " caFieldError" : ""}`}>
                        <label>Civilité *</label>
                        <FCSelect
                            options={optionCivility}
                            value={dataUser.civility}
                            onChange={(v) => eventChange("civility", String(v))}
                            placeholder="— Sélectionner —"
                        />
                    </div>

                    <div className="caField">
                        <label htmlFor="titleJob">Poste / statut</label>
                        <input id="titleJob" type="text" placeholder="Développeur Full-Stack"
                               value={dataUser.titleJob}
                               onChange={(e) => eventChange("titleJob", e.target.value)}/>
                    </div>

                    <div className="caField caFieldFull">
                        <label htmlFor="urlCV">CV / Portfolio URL</label>
                        <input id="urlCV" type="url" placeholder="https://..."
                               value={dataUser.urlCV}
                               onChange={(e) => eventChange("urlCV", e.target.value)}/>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateAccountUser;
